import {
  Identifiable,
  ProjectExpense,
  ProjectExpenseType,
  Project,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    expenses: Identifiable<ProjectExpense>[];
  };
};

function getProjectExpenses(httpClient: HttpClient) {
  return (project: Identifiable<Project>) =>
    new Promise<Identifiable<ProjectExpense>[]>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Response>({
          endpoint: `/expenses/search/rsql?page=0&size=9999&query=project.uuid==${project.uuid}`,
          method: HttpMethods.GET,
        })
        .then(({ _embedded }) => (_embedded ? _embedded.expenses : []))
        .then(
          async (expenses) =>
            await Promise.all(
              expenses.map(async (expense) => ({
                ...expense,
                expenseType: await httpClient.sendHttpRequest<
                  Identifiable<ProjectExpenseType>
                >({
                  endpoint: `/expenses/${expense.uuid}/expenseType`,
                  method: HttpMethods.GET,
                }),
              })),
            ),
        )
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { getProjectExpenses };
